import { type PlatformLicense } from "@/features/platform-license/contract";
import type { CreatorPackage } from "@/features/creator-packages/contract";
import { INTERNAL_TEST_PRICE_FEN, isInternalTestAvatarId } from "./internal-test-avatar";
import { publicProfileText } from "@/features/plaza/public-profile";
type PlazaPrice = {
  id?: string;
  creatorPackages?: CreatorPackage[];
  price: number;
  priceUnit: string;
  priceLabel: string;
};

export const plazaEcommerceReferencePrice = { kind: "电商", amount: 500, unit: "月" } as const;

export const plazaMinimumPrices = [
  { kind: "影视", amount: 1_000, unit: "部" },
  plazaEcommerceReferencePrice,
  { kind: "TVC 广告", amount: 1_000, unit: "条" },
] as const;

export function plazaReferencePrices(id: string) {
  return isInternalTestAvatarId(id)
    ? plazaMinimumPrices.map(item => ({ ...item, amount: INTERNAL_TEST_PRICE_FEN / 100 }))
    : plazaMinimumPrices;
}

export function formatPlazaPrice(
  avatar: PlazaPrice,
  pendingLabel = "付费授权 · 价格待确认",
) {
  if (avatar.id && isInternalTestAvatarId(avatar.id)) return "0.01元/部";
  if (avatar.price <= 0) return pendingLabel;
  const label = publicProfileText(avatar.priceLabel, "")
    .replace(/[（(][A-Z]级(?:[：:][^）)]*)?[）)]/gu, "")
    .trim();
  if (label && !label.includes("免费") && !label.includes("套餐")) return label;
  return `¥${avatar.price.toLocaleString("zh-CN")}/${publicProfileText(avatar.priceUnit, "部")}`;
}

export function plazaStartingPrice(id: string, price?: number) {
  return price === 0.01 ? 0.01 : Math.min(...plazaReferencePrices(id).map(item => item.amount));
}

export function formatPlazaStartingPrice(avatar: { id: string; price?: number; license?: PlatformLicense }) {
  return `¥${plazaStartingPrice(avatar.id, avatar.price).toLocaleString("zh-CN")} 起`;
}
